module.exports = __webpack_public_path__ + "img/blurred_pp_dashboard.513f84d8.png";